module.exports = __webpack_public_path__ + "img/ourprocess-desktop-min-cropped.d46e319.jpg";